export default __webpack_public_path__ + "static/media/assets-icon.e412f22b.svg";